import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Camera } from "lucide-react";

const images = [
  "/AQIQAH1.jpg",
  "/AQIQAH2.jpg",
  "/AQIQAH3.jpg",
  "/AQIQAH4.jpg",
  "/AQIQAH5.jpeg", // ✅ disesuaikan untuk file terakhir
];

const Gallery = () => {
  const [index, setIndex] = useState(0);

  const nextImage = () => setIndex((prev) => (prev + 1) % images.length);
  const prevImage = () =>
    setIndex((prev) => (prev - 1 + images.length) % images.length);

  // 🌀 Auto-slide tiap 4 detik (opsional tapi enak dilihat)
  useEffect(() => {
    const timer = setInterval(nextImage, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section
      id="gallery"
      className="relative py-10 md:py-20 px-6 bg-gradient-to-b from-[#FFF8F6] via-[#FFF5F2] to-[#FFFFFF] overflow-hidden"
    >
      {/* 🌸 Background Pattern */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 1L12 23M1 12L23 12' stroke='%23FF8A65' stroke-width='0.4'/%3E%3C/svg%3E")`,
          backgroundRepeat: "repeat",
        }}
      />

      {/* 🌈 Gradient Accents */}
      <div className="absolute -top-10 -left-10 w-64 h-64 bg-[#FFC4B2]/40 blur-[100px] rounded-full opacity-50" />
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#58B09C]/30 blur-[100px] rounded-full opacity-40" />

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        {/* ✨ Heading */}
        <h2
          className="text-3xl md:text-5xl font-extrabold text-[#333] mb-4"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          Galeri <span className="text-[#FF8A65]">Toyibah Aqiqah</span>
        </h2>
        <p className="text-[#777] text-sm md:text-lg mb-8 md:mb-12 max-w-2xl mx-auto leading-relaxed">
          Momen terbaik dari penuh keberkahan.
        </p>

        {/* 📸 Carousel */}
        <div className="relative w-full max-w-3xl mx-auto overflow-hidden rounded-3xl shadow-[0_10px_30px_rgba(255,138,101,0.15)]">
          <AnimatePresence mode="wait">
            <motion.img
              key={index}
              src={images[index]}
              alt={`Aqiqah ${index + 1}`}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.5 }}
              className="w-full h-[230px] sm:h-[350px] md:h-[420px] object-cover rounded-3xl"
            />
          </AnimatePresence>

          {/* 🔘 Controls */}
          <button
            onClick={prevImage}
            className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/70 text-[#FF8A65] hover:bg-[#FF8A65] hover:text-white rounded-full p-2 shadow-md transition-all duration-300"
            aria-label="Sebelumnya"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <button
            onClick={nextImage}
            className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/70 text-[#FF8A65] hover:bg-[#FF8A65] hover:text-white rounded-full p-2 shadow-md transition-all duration-300"
            aria-label="Selanjutnya"
          >
            <ChevronRight className="w-6 h-6" />
          </button>

          {/* 🟣 Indicator Dots */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
            {images.map((_, i) => (
              <motion.div
                key={i}
                onClick={() => setIndex(i)}
                className={`w-3 h-3 rounded-full cursor-pointer transition-all ${
                  i === index
                    ? "bg-[#FF8A65] scale-110"
                    : "bg-[#FFD8C8] hover:bg-[#FFB199]"
                }`}
                whileTap={{ scale: 0.8 }}
              />
            ))}
          </div>
        </div>

        {/* Decorative Label */}
        <div className="flex justify-center mt-10">
          <div className="flex items-center gap-2 text-[#FF8A65] font-semibold">
            <Camera className="w-5 h-5" />
            <span>Dokumentasi Toyibah Aqiqah</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
